export default __webpack_public_path__ + "static/media/pass.4cc49dd8.svg";